import dynamic from 'next/dynamic';
import { EventDetailsProps } from './EventDetails.types';

export const EventDetails = dynamic<{ model: EventDetailsProps }>(() =>
  import('./EventDetails').then(mod => mod.EventDetails)
);
